





















exports.default =
  props: ['voipCall']

  methods:
    viewContact: ->
      return unless @voipCall.contact.id
      @$router.push path: @contactPath()

    contactPath: ->
      "/contatos/#{@voipCall.contact.id}"

  computed:
    type: ->
      if @voipCall?.phone_number_kind == "mobile"
        "celular"
      else
        "fixo"

    created_at: ->
      m = moment(@voipCall.created_at)
      "#{m.format('D')} #{m.format('MMM').toUpperCase()}/#{m.format('YY')}"

    bill_duration: ->
      m = moment.utc(@voipCall.bill_duration*1000)
      hours = m.format('HH')
      minutes = m.format('mm')

      if parseInt(hours) > 0
        "#{hours}h e #{minutes} min"
      else
        "#{minutes} min"



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/voip_report/list_item.vue